/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Campaign
 */
export interface Campaign {
    /**
     * The campaign code
     * @type {string}
     * @memberof Campaign
     */
    code?: string;
    /**
     * The campaign name
     * @type {string}
     * @memberof Campaign
     */
    name?: string;
    /**
     * The start date of the campaign
     * @type {string}
     * @memberof Campaign
     */
    startDate?: string;
    /**
     * The end date of the campaign
     * @type {string}
     * @memberof Campaign
     */
    endDate?: string;
}

/**
 * Check if a given object implements the Campaign interface.
 */
export function instanceOfCampaign(value: object): value is Campaign {
    return true;
}

export function CampaignFromJSON(json: any): Campaign {
    return CampaignFromJSONTyped(json, false);
}

export function CampaignFromJSONTyped(json: any, ignoreDiscriminator: boolean): Campaign {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
    };
}

export function CampaignToJSON(json: any): Campaign {
    return CampaignToJSONTyped(json, false);
}

export function CampaignToJSONTyped(value?: Campaign | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

